const gradeIcons = {
  rentalIcon: '/images/grade_icon/Type=car, Rating=RENTAL.svg',
  freeIcon: '/images/grade_icon/Type=car, Rating=FREE.svg',
  normalIcon: '/images/grade_icon/Type=car, Rating=NORMAL.svg',
  rareIcon: '/images/grade_icon/Type=car, Rating=RARE.svg',
  eliteIcon: '/images/grade_icon/Type=car, Rating=ELITE.svg',
  epicIcon: '/images/grade_icon/Type=car, Rating=EPIC.svg',
  ultimateIcon: '/images/grade_icon/Type=car, Rating=ULTIMATE.svg',
  silver: '/images/grade_icon/Type=car box, Rating=NORMAL.svg',
  green: '/images/grade_icon/Type=car box, Rating=RARE.svg',
  blue: '/images/grade_icon/Type=car box, Rating=ELITE.svg',
  orange: '/images/grade_icon/Type=car box, Rating=EPIC.svg',
  red: '/images/grade_icon/Type=car box, Rating=ULTIMATE.svg',
};

export default gradeIcons;
